// gj-hero-slider.js
(function () {
  document.querySelectorAll('[data-gj-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-gj-slide]');
    var dots = hero.querySelectorAll('[data-gj-dot]');
    var autoplay = hero.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(hero.getAttribute('data-autoplay-speed'), 10) || 6000;
    var current = 0;
    var timer;

    function show(index) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      current = index;
    }
    function next() { show((current + 1) % slides.length); }
    function prev() { show((current - 1 + slides.length) % slides.length); }
    function restart() {
      clearInterval(timer);
      if (slides.length > 1 && autoplay) {
        timer = setInterval(next, speed);
      }
    }

    var nextBtn = hero.querySelector('[data-gj-next]');
    var prevBtn = hero.querySelector('[data-gj-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { show(parseInt(dot.dataset.gjDot, 10)); restart(); });
    });
    restart();
  });
})();
